import React, { Component } from "react";
import Img from "gatsby-image";
import Lightbox from "react-image-lightbox";

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal(index) {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
      photoIndex: index
    }));
    if (this.state.isOpen) {
      document.querySelector("#site").classList.add("is-clipped");
    } else {
      document.querySelector("#site").classList.remove("is-clipped");
    }
  }

  render() {
    const { photoIndex, isOpen } = this.state;
    const images = [];
    this.props.items.map(item => {
      images.push(item.localFile.childImageSharp.sizes.src);
      return "done";
    });

    return (
      <div>
        <div className="columns is-multiline is-gallery">
          {this.props.items.map((item, index) => (
            <div className={`column is-${this.props.column}`}>
              <figure
                className="image is-square"
                onClick={() => this.toggleModal(index)}
              >
                <Img
                  sizes={item.localFile.childImageSharp.sizes}
                  alt={item.alt_text}
                />
              </figure>
            </div>
          ))}
        </div>

        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            enableZoom={false}
            onCloseRequest={() => this.toggleModal()}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </div>
    );
  }
}
export default Gallery;
